const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
  prefix: 'tw-',
  exposeConfig: true,
  plugins: [
    require('@tailwindcss/forms')({
      strategy: 'class'
    }),
    require('@tailwindcss/aspect-ratio'),
    require('@tailwindcss/line-clamp'),
    require('@tailwindcss/typography')
  ],
  theme: {
    fontFamily: {
      sans: 'Lexend, fb-segoe, fb-roboto, fb-futura, fb-helvetica, fb-arial, Arial, sans-serif, "Apple  Color Emoji", "Segoe UI Emoji", "Segoe  UI Symbol"',
    },
    screens: {
      xs: '321px',
      ...defaultTheme.screens,
    },
    extend: {
      minHeight: {
        48: '12rem'
      },
      lineClamp: {
        10: '10',
      },
      typography: {
        DEFAULT: {
          css: {
            h2: {
              fontWeight: '500'
            },
            h3: {
              fontWeight: '500'
            }
          },
        },
      },
      spacing: {
        104: '26rem',
        112: '28rem',
        120: '30rem',
      },
      colors: {
        gray: {
          25: '#FDFDFC',
          50: '#FAFAF9',
          100: '#F5F5F4',
          200: '#E7E5E4',
          300: '#D6D3D1',
          400: '#A8A29E',
          500: '#78716C',
          600: '#57534E',
          700: '#44403C',
          800: '#292524',
          900: '#1C1917',
        },
        red: {
          25: '#FFFAFA',
          50: '#FFEDED',
          100: '#FFE0E0',
          200: '#FED2D2',
          300: '#FF9292',
          400: '#FF5151',
          500: '#E03131',
          600: '#BF3335',
          700: '#9D3438',
          800: '#7A2828',
          900: '#5A0000',
        },
        blue: {
          25: '#F8FBFC',
          50: '#EBF7FA',
          100: '#DFF1F5',
          200: '#D2EBF0',
          300: '#94D6E3',
          400: '#53BACF',
          500: '#0EA4C2',
          600: '#0B8199',
          700: '#005F73',
          800: '#035060',
          900: '#05414D',
        },
        green: {
          25: '#F7FCFB',
          50: '#E6F2ED',
          100: '#CAE8DC',
          200: '#ADDECB',
          300: '#7BD2B1',
          400: '#41CA95',
          500: '#06C179',
          600: '#008A55',
          700: '#037046',
          800: '#035837',
          900: '#104631',
        },
        yellow: {
          25: '#FFFDF7',
          50: '#FFFCF0',
          100: '#FFF7D9',
          200: '#FFEDAC',
          300: '#FFE070',
          400: '#F6C000',
          500: '#D9AF16',
          600: '#BC9D2C',
          700: '#998128',
          800: '#806C22',
          900: '#67571B',
        },
        cream: {
          25: '#FFFEFC',
          50: '#FAF6F3'
        },
        latte: {
          300: '#E9DDD0'
        }
      },
      lineHeight: {
        'extra-tight': '1.1',
      }
    }
  },
}
